export const CONTACTS = {
	TABLE_HEADERS: [
		{
			name: 'Name',
			value: 'lastName',
			className: 'name',
		},
		{
			name: 'Email',
			value: 'email',
			className: 'email',
		},
		{
			name: 'Phone',
			value: 'phone',
			className: 'phone',
		},
		{
			name: 'Type',
			value: 'type',
			className: 'type',
		},
		{
			name: 'Owner',
			value: 'owner',
			className: 'owner',
		},
	],
};

export const ALERT_TYPES = {
	BIRTHDAY: 'Birthday',
	RATE: 'Rate',
	CREDIT: 'Credit',
	UNITE: 'Unite',
	UCONNECT: 'UConnect',
	MI_DROP_ELIGIBLE: 'MI Drop Eligible',
	NEW_LISTING: 'New Listing',
	LOAN_ANNIVERSARY: 'Loan Anniversary',
	REVIEW_ME: 'Review Me',
};

export const ACTIVITY_TYPES = {
	AUTOMATIC_ALERT_EMAIL: 'AutomaticAlertEmail',
	MANUAL_ALERT_EMAIL: 'ManualAlertEmail',
	LOAN_ALERT: 'LoanAlert',
	LEAD_ALERT: 'LeadAlert',
	LOAN: 'Loan',
	LEAD: 'Lead',
	ALERT_NOTE: 'AlertNote',
	LEAD_NOTE: 'LeadNote',
	LOAN_NOTE: 'LoanNote',
	DRIP_CAMPAIGN: 'DripCampaign',
	BLINK_LOAN_IMPORT: 'BlinkLoanImport',
	BLINK_LOAN_EXPORT: 'BlinkLoanExport',
	BLINK_LEAD_IMPORT: 'BlinkLeadImport',
	BLINK_LEAD_EXPORT: 'BlinkLeadExport',
	EASE_LOAN_IMPORT: 'EaseLoanImport',
	EASE_LEAD_IMPORT: 'EaseLeadImport',
	BRAND_BUILDER_EMAIL: 'BrandBuilderEmail',
};

export const ALERTS = {
	TABLE_HEADERS: [
		{
			name: 'Type',
			value: 'type',
			className: 'type',
		},
		{
			name: 'Contact',
			value: 'lastName',
			className: 'contact',
		},
		{
			name: 'Date',
			value: 'alertDateTime',
			className: 'date',
		},
		{
			name: 'Status',
			value: 'status',
			className: 'status',
		},
		{
			name: 'Owner',
			value: 'owner',
			className: 'owner',
		},
	],
	STATUSES: {
		NEW: 'New',
		TO_DO: 'To-Do',
		DISMISSED: 'Dismissed',
		DONE: 'Done',
		DONE_FOR_YOU: 'Done For You',
		SCHEDULED: 'Scheduled',
		UPCOMING: 'Upcoming',
	},
	TYPE_ICONS: [
		{
			type: ALERT_TYPES.BIRTHDAY,
			icon: ['far', 'birthday-cake'],
		},
		{
			type: ALERT_TYPES.RATE,
			icon: ['far', 'eye'],
		},
		{
			type: ALERT_TYPES.CREDIT,
			icon: ['far', 'monitor-heart-rate'],
		},
		{
			type: ALERT_TYPES.UNITE,
			icon: ['far', 'percent'],
		},
		{
			type: ALERT_TYPES.UCONNECT,
			icon: ['far', 'chart-line'],
		},
		{
			type: ALERT_TYPES.MI_DROP_ELIGIBLE,
			icon: ['far', 'shield-check'],
		},
		{
			type: ALERT_TYPES.NEW_LISTING,
			icon: ['far', 'map-marker-smile'],
		},
		{
			type: ALERT_TYPES.LOAN_ANNIVERSARY,
			icon: ['far', 'home-heart'],
		},
		{
			type: ALERT_TYPES.REVIEW_ME,
			icon: ['far', 'star'],
		},
		{
			type: 'Loan Listing',
			icon: ['far', 'home-lg-alt'],
		},
		{
			type: 'New Alerts',
			icon: ['far', 'bell-on'],
		},
		{
			type: 'Alert',
			icon: ['far', 'bell'],
		},
		{
			type: 'Email',
			icon: ['far', 'at'],
		},
		{
			type: ACTIVITY_TYPES.AUTOMATIC_ALERT_EMAIL,
			icon: ['far', 'at'],
		},
		{
			type: ACTIVITY_TYPES.MANUAL_ALERT_EMAIL,
			icon: ['far', 'at'],
		},
		{
			type: ACTIVITY_TYPES.DRIP_CAMPAIGN,
			icon: ['far', 'at'],
		},
		{
			type: ACTIVITY_TYPES.BRAND_BUILDER_EMAIL,
			icon: ['far', 'at'],
		},
		{
			type: ACTIVITY_TYPES.LOAN_ALERT,
			icon: ['far', 'bell'],
		},
		{
			type: ACTIVITY_TYPES.LEAD_ALERT,
			icon: ['far', 'bell'],
		},
		{
			type: ACTIVITY_TYPES.LOAN,
			icon: ['far', 'home-lg-alt'],
		},
		{
			type: ACTIVITY_TYPES.LEAD,
			icon: ['far', 'user-alt'],
		},
		{
			type: ACTIVITY_TYPES.LEAD_NOTE,
			icon: ['far', 'sticky-note'],
		},
		{
			type: ACTIVITY_TYPES.ALERT_NOTE,
			icon: ['far', 'sticky-note'],
		},
		{
			type: ACTIVITY_TYPES.LOAN_NOTE,
			icon: ['far', 'sticky-note'],
		},
		{
			type: ACTIVITY_TYPES.BLINK_LEAD_IMPORT,
			icon: ['far', 'file-import'],
		},
		{
			type: ACTIVITY_TYPES.BLINK_LOAN_IMPORT,
			icon: ['far', 'file-import'],
		},
		{
			type: ACTIVITY_TYPES.BLINK_LEAD_EXPORT,
			icon: ['far', 'file-export'],
		},
		{
			type: ACTIVITY_TYPES.BLINK_LOAN_EXPORT,
			icon: ['far', 'file-export'],
		},
		{
			type: ACTIVITY_TYPES.EASE_LEAD_IMPORT,
			icon: ['far', 'file-import'],
		},
		{
			type: ACTIVITY_TYPES.EASE_LOAN_IMPORT,
			icon: ['far', 'file-import'],
		},
	],
};

export const TYPES = {
	ALERT: 'Alert Type',
	CONTACT: 'Contact Type',
	STATUS: 'Status',
	DATE_RANGE: 'Date Range',
	OWNER: 'Owner',
	LOAN_TYPE: 'Loan Type',
	LOAN_PURPOSE: 'Loan Purpose',
	SEARCH: 'Search',
	FILTERS: 'Filters',
};

export const FILTER_VIEWS = {
	HOME: 'Filters',
	OWNER: 'Owner',
};

export const STATUS_ACTION_TYPES = {
	NEW: 1,
	TO_DO: 2,
	SCHEDULED: 3,
	DONE_FOR_YOU: 5,
	DONE: 6,
	DISMISSED: 7,
};

export const DEFAULT_STATUS_FILTERS = [
	STATUS_ACTION_TYPES.NEW,
	STATUS_ACTION_TYPES.TO_DO,
	STATUS_ACTION_TYPES.DONE,
	STATUS_ACTION_TYPES.DONE_FOR_YOU,
	STATUS_ACTION_TYPES.DISMISSED,
];

export const DATE_RANGE_TYPES = {
	PREVIOUS_30_DAYS: -30,
	TODAY: -1,
};
